import angular from "angular";
import template from "./campus-zones-index.html";
import AdminSchoolsLocationsZonesIndexController from "./campus-zones-index.controller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.schools.view.locations.zones.index", {
    url: "/:locationId/index",
    controller: AdminSchoolsLocationsZonesIndexController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.schools.view.locations.zones.index", [])
  .config(config)
  .controller(
    "AdminSchoolsLocationsZonesIndexController",
    AdminSchoolsLocationsZonesIndexController,
  );

